import { useAuth0 } from '@auth0/auth0-react'
import type { FC, PropsWithChildren } from 'react'

import { Landing } from './Landing'
import { Unauthorized } from './Unauthorized'

interface Props {
  allowed?: boolean
}

export const ProtectedRoute: FC<PropsWithChildren<Props>> = ({
  children,
  allowed = false,
}) => {
  const { isAuthenticated, user } = useAuth0()

  if (!isAuthenticated || !user) {
    return <Landing />
  }
  if (!allowed) return <Unauthorized />

  return <>{children}</>
}
